/* eslint-disable no-extra-boolean-cast */
import moment from 'moment';
import { format, subYears } from 'date-fns';
import 'moment/locale/tr';
import { tr } from 'date-fns/locale';

/**
 * Returns a formatted phone number with country code +90
 * @param {string} phoneNumberString
 * @returns {(string|null)} returns the formatted phone number or null
 */
export const formatPhoneNumber = phoneNumberString => {
  let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  let match = cleaned.match(/^(90|)?(\d{3})(\d{3})(\d{2})(\d{2})$/);

  if (match) {
    let intlCode = match[1] ? '+90 ' : '+90 ';
    return [intlCode, '(', match[2], ') ', match[3], ' ', match[4], ' ', match[5]].join('');
  }
  return null;
};

/**
 * Returns a unformatted phone number without country code (+90) etc.
 * @param {string} formattedPhoneNumber
 * @returns {(string|null)} returns the unformatted phone number or null
 */
export const unFormatPhoneNumber = formattedPhoneNumber => {
  if (formattedPhoneNumber) {
    return formattedPhoneNumber
      .replace(/\s/g, '')
      .replace('90', '')
      .replace('+', '')
      .replace('(', '')
      .replace(')', '')
      .replace('_', '');
  }

  return null;
};

/**
 * Returns date in dd/mm/yyyy format
 * @param {date} datum
 * @returns {(string|null)} based on the input
 */
export const formatDate = datum => {
  if (!datum) return null;

  let myDate = new Date(datum);

  // let prettyDate =
  //   ('0' + myDate.getDate()).slice(-2) +
  //   '/' +
  //   ('0' + (myDate.getMonth() + 1)).slice(-2) +
  //   '/' +
  //   myDate.getFullYear();

  const prettyDate = moment(myDate).format('DD/MM/YYYY');

  return prettyDate;
};

/**
 * Returns date in mm/yy format
 * @param {date} datum
 * @returns {(string|null)} based on the input
 */
export const formatExpireDate = datum => {
  if (!datum) return null;
  let myDate = new Date(datum);

  if (myDate.getTime() < 0) return '-';

  let prettyDate =
    ('0' + (myDate.getMonth() + 1)).slice(-2) + '/' + myDate.getFullYear().toString().slice(-2);

  return prettyDate;
};

/**
 * Returns date in dd/mm/yyyy hh:mm format
 * @param {date} datum
 * @returns {(string|null)} based on the input
 */
export const formatDateWithHours = datum => {
  // check this function
  if (!datum) return '-';

  let myDate = new Date(datum);

  const prettyDate = moment(myDate).format('DD/MM/YYYY HH:mm');

  return prettyDate;
};

/**
 * Returns date in yyyy-mm-dd format
 * @param {string} date
 * @returns {string}
 */
export const newDate = date => {
  return date.split('/').reverse().join('-');
};

/**
 * Returns date in Date object type
 * @param {string} datum
 * @returns {Date}
 */
export const convertDate = datum => {
  if (!datum) return null;
  const date = datum.split('-').reverse().join('-');

  return new Date(date);
};

/**
 * Returns date string
 * @param {string} datum
 * @returns {string}
 */
export const convertDateString = datum => {
  if (!datum) return null;
  const date = datum.split('-').length > 2 ? datum.split('-').join('/') : '';

  return date;
};

/**
 * Returns date in dd-MM-yyyy format with date-fns => for post method purposes
 * @param {Date} datum
 * @returns {string}
 */
export const convertPostDate = datum => {
  if (!datum) return null;

  return format(datum, 'dd-MM-yyyy');
};

/*
 * Returns date in dd-MM-yyyy HH:mm format with date-fns => for post method purposes
 * @param {Date} datum
 * @returns {string}
 */
export const convertPostDateWithHours = datum => {
  if (!datum) return null;

  return format(datum, 'dd-MM-yyyy HH:mm');
};

/**
 * Returns date in YYYY-MM-DD format with moment => for post method purposes
 * @param {string} datum
 * @returns {string}
 */
export const convertPostDateTR = datum => {
  if (!datum) return null;

  const date = datum.split('/').reverse().join('-');

  return moment(date).format('YYYY-MM-DD');
};

/**
 * Returns date in YYYYMMDD format with moment
 * @param {string} datum
 * @returns {string}
 */

export const convertDateWithoutFormat = datum => {
  if (!datum) return null;

  const dateObj = new Date(datum);
  return moment(dateObj).format('YYYYMMDD');
};

// *** isAfter today? ***
export const isBeforeToday = datum => {
  if (!datum) return null;
  const dateObj = new Date(datum);
  const isBefore = moment().startOf('day').isAfter(dateObj);

  return isBefore;
};

export const convertStringToDate = string => {
  return moment(String(string)).format('DD/MM/YYYY');
};

export const convertStringToDateWithHours = string => {
  const pattern = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
  const date = string.replace(pattern, '$1-$2-$3 $4:$5:$6');

  return moment(date).format('DD/MM/YYYY HH:mm:ss');
};

export const convertStringHours = string => {
  const pattern = /(\d{2})(\d{2})(\d{2})/;
  const time = String(string).replace(pattern, '$1:$2:$3');

  const timeData = moment(time).isValid() ? time.slice(0, 8) : '';
  return timeData;
};

/**
 * Returns date in YYYY-MM-DD HH:mm UTC-0 format with moment => for post method purposes
 * @param {string} datum
 * @returns {string}
 */
export const convertUTCPostDateWithHour = datum => {
  if (!datum) return null;

  return moment(datum).utc().format('YYYY-MM-DD HH:mm');
};

/**
 * Returns the legal limit ages date for "birthdate" datepickers maxDate props from now
 * @returns {Date}
 */
export const getLegalAgeDate = () => subYears(new Date(), 18);

/**
 * Date difference
 */
export const dateDifference = transferDate => {
  const date2 = new Date(transferDate);

  // To calculate the time difference of two dates
  const Difference_In_Time = Date.now() - date2.getTime();

  // To calculate the no. of days between two dates
  const Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

  if (!transferDate) {
    return 0; // not enterred transfer period
  } else if ([0, 1, 2].includes(Difference_In_Days)) {
    return 1; // being transferred
  } else if (Difference_In_Days >= 3) {
    return 2; // transferred
  }
};

/**
 * Returns return date without UTC Timezone - DD/MM/YYY HH:mm
 * @param {string} date
 * @returns {string}
 *
 */

export const getUTCDate = datum => {
  const utcDate = moment(datum).utc().format();
  return utcDate;
};

/*
 * Returns date without UTC Timezone
 * @param {string} date
 * @returns {string}
 *
 */

export const getUTCDateWithFormat = datum => {
  const utcDate = moment(datum).utc().format('DD/MM/YYYY HH:mm');
  return utcDate;
};

/*
 * get current month start and end day
 */

export const getStartEndDateMonth = () => {
  const startDay = moment().startOf('month').format('DD/MM/YYYY HH:mm');
  const endDay = moment().endOf('month').format('DD/MM/YYYY HH:mm');
  return { start_date: startDay, end_date: endDay };
};

/*
 * get Hour:Minute
 *
 */

export const getHourMinute = datum => {
  const date = new Date(datum);
  const hour = date.getHours(date);
  const minute = date.getMinutes(date);

  return `${hour}:${minute}`;
};

/*
 * daily filter => return startDay - endDay
 *
 */

export const dailyFilter = () => {
  const endDay = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
  const startDay = moment().subtract(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss');

  return { start: startDay, end: endDay };
};

/*
 *  weekly filter => return startDay - endDay
 *
 */

export const weeklyFilter = () => {
  const endDay = moment().endOf('day').format('YYYY-MM-DD HH:mm');
  const startDay = moment().subtract(7, 'day').startOf('day').format('YYYY-MM-DD HH:mm');
  return { start: startDay, end: endDay };
};

/*
 *  weekly filter => return startDay - endDay
 *
 */

export const weeklyFilterWithoutHour = () => {
  const endDay = moment().endOf('day').format('YYYY-MM-DD');
  const startDay = moment().subtract(7, 'day').startOf('day').format('YYYY-MM-DD');
  return { start: startDay, end: endDay };
};

/*
 * monthly filter => return startDay - endDay
 *
 */

export const monthlyFilter = () => {
  const endDay = moment().endOf('day').format('YYYY-MM-DD HH:mm');
  const startDay = moment().subtract(1, 'month').startOf('day').format('YYYY-MM-DD HH:mm');
  return { start: startDay, end: endDay };
};

/*
 * monthly filter => return  existing month startDay - endDay
 *
 */

export const existingMonthlyFilter = () => {
  const endDay = moment().endOf('month').format('YYYY-MM-DD HH:mm');
  const startDay = moment().startOf('month').format('YYYY-MM-DD HH:mm');
  return { start: startDay, end: endDay };
};

/*
 * monthly filter => return  existing year startDay - endDay
 *
 */

export const existingYearlyFilter = () => {
  const endDay = moment().endOf('year').format('YYYY-MM-DD HH:mm');
  const startDay = moment().startOf('year').format('YYYY-MM-DD HH:mm');
  return { start: startDay, end: endDay };
};

// minDate today 23:59
export const minDateToday = endDate => {
  const today = moment().endOf('day').format('YYYY-MM-DD HH:mm');
  return endDate > today ? today : endDate;
};

// minDate after today - without hour
export const minDateAfterToday = moment().endOf('day').add(1).format('YYYY-MM-DD');

// minDate startOf this year
export const minDateStartOfYear = moment().startOf('year').format('YYYY-MM-DD HH:mm');

// Holiday detail id format
export const convertHolidayFormat = datum => {
  if (!!datum) {
    const date = datum.replace(/[^\d ]/g, '');
    return date;
  }
  return null;
};

/*
 * amount transition => cent (kuruş) to lira
 *
 */

export const moneyTransition = amount => {
  return parseFloat(amount / 100).toFixed(2);
};

/*
 * Formatted money - TRY Currency
 *
 */

export const formattedMoney = amount => {
  return new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency: 'TRY',
    maximumFractionDigits: 2
  }).format(amount);
};

/*
 * Moment - months
 */
export const monthsArr = () => {
  moment.locale('tr');
  return moment.months();
};

// month - day search etc.
export const monthlyCalc = datum => {
  const months = moment.months('M');
  const currentYear = new Date().getFullYear();
  const monthsIndex = months.map((m, i) => i + 1);
  const formattedDays = datum?.map(dt => moment(dt.operation_at).format('YYYY-MM-DD'));
  const formatDay = dt => moment(dt).format('YYYY-MM-DD');

  // get formatted date by month
  const getDaysInMonth = (month, year) => {
    const ar = [];
    const start = moment(year + '-' + month, 'YYYY-MM');
    const end = moment(start).add(1, 'month');
    for (end; start.isBefore(end); start.add(1, 'day')) {
      ar.push(start.format('YYYY-MM-DD'));
    }
    return ar;
  };

  // get all days by year
  const calendarYear = monthsIndex.map(m => {
    return getDaysInMonth(m, currentYear);
  });

  // format calendar day by data type
  const formattedCalendar = calendarYear.map(month => {
    return month.map(m => {
      if (formattedDays?.includes(m)) {
        const date = datum.find(dt => formatDay(dt.operation_at) === m);
        return date;
      }
      return null;
    });
  });

  return formattedCalendar;
};

/*
 *  convert date to only - year => Year Picker
 */
export const convertYearOnly = datum => {
  return moment(datum).year();
};

/*
 * image encoding
 */

export const imageEncode = arrayBuffer => {
  // let u8 = new Uint8Array(arrayBuffer);
  let b64encoded = btoa(
    [].reduce.call(
      new Uint8Array(arrayBuffer),
      function (p, c) {
        return p + String.fromCharCode(c);
      },
      ''
    )
  );
  let mimetype = 'image/*';
  return 'data:' + mimetype + ';base64,' + b64encoded;
};
